import { chat as en_chat } from "../en/chat";

/** chat — ES slice (79 keys). */
export const chat: Record<keyof typeof en_chat, string> = {
  chat_messages_title: "Mensajes",
  chat_messages_unread: "{count} sin leer",
  chat_messages_empty_title: "Aún no hay mensajes",
  chat_messages_empty_description:
    "Cuando hagas match con alguien, podrás empezar una conversación aquí",
  chat_messages_loading: "Cargando mensajes...",
  chat_conversation_typing: "escribiendo...",
  chat_conversation_typing_multiple: "{count} personas están escribiendo",
  chat_conversation_no_messages: "Aún no hay mensajes",
  chat_conversation_no_messages_hint:
    "Envía un mensaje para empezar la conversación",
  chat_conversation_edited: "editado",
  chat_conversation_tap_to_retry: "Toca para reintentar",
  chat_input_placeholder: "Escribe un mensaje...",
  chat_input_attachment_gallery: "Galería",
  chat_input_attachment_camera: "Cámara",
  chat_input_attachment_file: "Archivo",
  chat_input_attachment_location: "Ubicación",
  chat_input_replying_to: "Respondiendo a {name}",
  chat_attachment_photo: "Foto",
  chat_attachment_video: "Video",
  chat_attachment_voice: "Mensaje de voz",
  chat_attachment_file: "Archivo",
  chat_attachment_location: "Ubicación",
  chat_actions_reply: "Responder",
  chat_actions_copy: "Copiar",
  chat_actions_edit: "Editar",
  chat_actions_delete: "Eliminar",
  chat_actions_forward: "Reenviar",
  chat_conversation_actions_archive: "Archivar",
  chat_conversation_actions_unarchive: "Desarchivar",
  chat_conversation_actions_mute: "Silenciar",
  chat_conversation_actions_unmute: "Reactivar sonido",
  chat_conversation_actions_pin: "Fijar",
  chat_conversation_actions_unpin: "Desfijar",
  chat_conversation_actions_delete: "Eliminar",
  chat_conversation_actions_block: "Bloquear usuario",
  chat_time_just_now: "Justo ahora",
  chat_time_yesterday: "Ayer",
  chat_delete_confirm_title: "Eliminar mensaje",
  chat_delete_confirm_message: "¿Seguro que quieres eliminar este mensaje?",
  chat_delete_confirm_cancel: "Cancelar",
  chat_delete_confirm_delete: "Eliminar",
  chat_block_confirm_title: "Bloquear usuario",
  chat_block_confirm_message:
    "¿Seguro que quieres bloquear a {name}? No podrá enviarte mensajes.",
  chat_block_confirm_cancel: "Cancelar",
  chat_block_confirm_block: "Bloquear",
  chat_error_send_failed: "No se pudo enviar el mensaje",
  chat_error_load_failed: "No se pudieron cargar los mensajes",
  chat_error_connection: "Conexión perdida. Reconectando...",
  chat_options_title: "Opciones",
  chat_options_leave_channel: "Salir del canal",
  chat_options_leave_group: "Salir del grupo",
  chat_options_leaving: "Saliendo...",
  chat_options_no_options: "No hay opciones disponibles",
  chat_leave_channel_title: "¿Salir del canal?",
  chat_leave_channel_message:
    "¿Seguro que quieres salir de este canal? Podrás volver a unirte si es público o si alguien te invita de nuevo.",
  chat_leave_group_title: "¿Salir del grupo?",
  chat_leave_group_message:
    "¿Seguro que quieres salir de este grupo? Podrás volver a unirte si es público o si alguien te invita de nuevo.",
  chat_leave_confirm_cancel: "Cancelar",
  chat_leave_confirm_leave: "Salir",
  chat_leave_error: "No se pudo salir de {type}. Inténtalo de nuevo.",
  chat_channel_admin_only:
    "Solo los administradores pueden publicar en este canal",
  chat_discover_title: "Descubrir canales",
  chat_discover_invite_placeholder: "Introduce el código de invitación...",
  chat_discover_join_button: "Unirse",
  chat_discover_public_channels: "Canales públicos",
  chat_discover_loading: "Cargando canales...",
  chat_discover_empty_title: "No se encontraron canales",
  chat_discover_empty_description:
    "Ahora mismo no hay canales públicos disponibles. Vuelve más tarde o únete usando un enlace de invitación.",
  chat_discover_channel_members: "{count} miembros",
  chat_discover_joining: "Uniéndose...",
  chat_discover_join_error: "No se pudo unir al canal. Inténtalo de nuevo.",
  chat_discover_invite_error:
    "Código de invitación no válido o no puedes unirte a este canal.",
  chat_discover_invite_empty_error: "Introduce un código de invitación.",
  chat_archive_error: "No se pudo archivar la conversación",
  chat_mute_error: "No se pudo silenciar la conversación",
  chat_pin_error: "No se pudo fijar la conversación",
  chat_delete_error: "No se pudo eliminar la conversación",
  chat_delete_conversation_title: "¿Eliminar conversación?",
  chat_delete_conversation_message:
    "¿Seguro que quieres eliminar esta conversación? Esto no se puede deshacer.",
};
